import { inject, InjectionToken } from '@angular/core';
import { Route } from '@angular/router';

import { DEFAULT_URL_MATCHER, UrlMatcherFactory, UrlMatcherService } from '@spartacus/core';
import { getSuffixUrlMatcher } from '@spartacus/storefront';

export function getRecipeListCategoryMatcherFactory(service: UrlMatcherService, defaultMatcherFactory: UrlMatcherFactory): UrlMatcherFactory {
  return (route: Route) => {
    const defaultMatcher = defaultMatcherFactory(route);
    const suffixCRPMatcher = getSuffixUrlMatcher({
      marker: 'crp',
      paramName: 'recipeCategoryCode'
    });
    return service.getCombined([defaultMatcher, suffixCRPMatcher]);
  };
}

export const RECIPE_CATEGORY_URL_MATCHER = new InjectionToken<UrlMatcherFactory>('RECIPE_CATEGORY_URL_MATCHER', {
  providedIn: 'root',
  factory: () => getRecipeListCategoryMatcherFactory(inject(UrlMatcherService), inject(DEFAULT_URL_MATCHER))
});
